export enum TIPOCORTETITULO {
  CORTE_INESPERADO = 'IMPREVISTO',
  CORTE_PROGRAMADO = 'PROGRAMADO',
  CORTE_FUTURO = 'Próximo corte programado',
}
